
const digest = '8e216d9dd9af55d69b35f6718542301db499028d22c2abe779b924be113ee81f';
const classes = {"wrapper":"_wrapper_1h85s_1"};
const css = `._wrapper_1h85s_1 {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
._wrapper_1h85s_1 svg {
  width: 100%;
  height: auto;
  display: block;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  